import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CandidateProfileForm from "@/components/forms/CandidateProfileForm";

export default function CandidateOnboardingPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto px-6 py-12 sm:py-16">
      <div className="mb-8 rounded-2xl bg-[#4ba3b7]/10 border border-[#4ba3b7]/20 p-4 text-sm text-[#2B2B2B]/80" data-testid="candidate-onboarding-banner">
        {t("auth.verificationBanner")}
      </div>
      <div className="bg-white rounded-2xl border border-black/5 shadow-[0_4px_24px_rgba(0,0,0,0.03)] p-6 sm:p-8">
        <CandidateProfileForm />
      </div>
      <button
        onClick={() => navigate("/dashboard/candidate")}
        className="block mx-auto mt-6 text-sm text-[#2B2B2B]/50 hover:underline"
        data-testid="candidate-onboarding-skip-link"
      >
        {t("common.close")}
      </button>
    </div>
  );
}
